import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkDialogEditComponent, } from 'jk-service';
import { jkRestReturn } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { Jcktl } from '../entity/Jcktl-angular';
import { JcktlService } from '../service/jcktl.service';


@Component({
  selector: 'app-jcktl-edit',
  templateUrl: './jcktl-edit.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule],
})

export class JcktlEditComponent extends JkDialogEditComponent<JcktlService, Jcktl> {
  override srv!: JcktlService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<JcktlEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
  }


}
